import * as Cookie from 'js-cookie';

export interface RequestIndexResult {
    isNeedFetch: boolean;
    offset: number;
    count: number;
}

export class SegmentManager {
    static readonly defaultTotal = 10000; // умолчательное количество строк в таблице неизвестного размера
    static readonly defaultSegmentSize = Number(Cookie.get('segment_size')) || 200; // умолчательное количество строк в сегменте
    private segments: Record<string, boolean> = {};

    constructor(
        private total: number = SegmentManager.defaultTotal,
        private segmentSize: number = SegmentManager.defaultSegmentSize
    ) {}

    requestIndex(rowIndex: number): RequestIndexResult | null {
        // после фильтрации количество строк может уменьшиться, однако вызовов requestIndex будет столько,
        // сколько было строк в таблице; для "лишних" строк возвращаем null чтобы нарисовались скелетоны;
        // после смены totalCount лишние строки пропадут
        if (rowIndex > this.total) {
            return null;
        }

        const segmentIndex = this.getSegmentIndexByRowIndex(rowIndex);

        if (this.segments[segmentIndex] === true) {
            return {
                isNeedFetch: false,
                offset: 0,
                count: 0
            };
        }

        this.segments[segmentIndex] = true;

        const { segmentSize: count } = this;
        const offset = segmentIndex * count;
        return {
            isNeedFetch: true,
            offset,
            // сount выступает в роли лимита в запросах айтемов с гридов
            // Из-за того, что эти запросы могут быть параллельными, может случиться так,
            // что total станет равен 0, а this.segments[segmentIndex] === undefined
            // Тогда все повалится с ошибкой от сервера
            // Чтобы этого не происходило, я вынес count в константу - segmentSize
            count
        };
    }

    setTotal(total: number): SegmentManager {
        this.total = total;

        return this;
    }

    reset(): SegmentManager {
        this.segments = {};
        this.total = SegmentManager.defaultTotal;

        return this;
    }

    private getSegmentIndexByRowIndex(index: number): number {
        return Math.floor(index / this.segmentSize);
    }
}
